import { serializationFileId, calcFileIdByteLength } from "../../modules/files/FileTypes";
import { BusMessage, calcStringByteLength, MessageFactory } from "flavr-common";
/**
 * Requests downloading a media file.
 */
export class DownloadMediaFileMessage extends BusMessage {
    get byteLength() {
        return calcFileIdByteLength(this.fileId) + calcStringByteLength(this.fileName);
    }
    constructor(fileId, fileName) {
        super();
        this.fileId = fileId;
        this.fileName = fileName;
    }
    serialization(stream) {
        this.fileId = serializationFileId(stream, this.fileId);
        this.fileName = stream.utf16String(this.fileName);
    }
    static is(msg) {
        return msg.type === DownloadMediaFileMessage.typestatic;
    }
}
DownloadMediaFileMessage.typestatic = "DownloadMediaFileMessage";
DownloadMediaFileMessage.subjectstatic = "general";
MessageFactory.register(DownloadMediaFileMessage);
/**
 * Requests downloading a text file.
 */
export class DownloadTextFileMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.fileName) + calcStringByteLength(this.text);
    }
    constructor(fileName, text) {
        super();
        this.fileName = fileName;
        this.text = text;
    }
    serialization(stream) {
        this.fileName = stream.utf16String(this.fileName);
        this.text = stream.utf16String(this.text);
    }
    static is(msg) {
        return msg.type === DownloadTextFileMessage.typestatic;
    }
}
DownloadTextFileMessage.typestatic = "DownloadTextFileMessage";
DownloadTextFileMessage.subjectstatic = "general";
MessageFactory.register(DownloadTextFileMessage);
/**
 * Requests copying a media file to the clipboard.
 */
export class CopyMediaFileToClipboardMessage extends BusMessage {
    get byteLength() {
        return calcFileIdByteLength(this.fileId);
    }
    constructor(fileId) {
        super();
        this.fileId = fileId;
    }
    serialization(stream) {
        this.fileId = serializationFileId(stream, this.fileId);
    }
    static is(msg) {
        return msg.type === CopyMediaFileToClipboardMessage.typestatic;
    }
}
CopyMediaFileToClipboardMessage.typestatic = "CopyMediaFileToClipboardMessage";
CopyMediaFileToClipboardMessage.subjectstatic = "general";
MessageFactory.register(CopyMediaFileToClipboardMessage);
/**
 * Requests sharing a media file.
 */
export class ShareMediaFileMessage extends BusMessage {
    get byteLength() {
        return calcFileIdByteLength(this.fileId) + calcStringByteLength(this.filename);
    }
    constructor(fileId, filename) {
        super();
        this.fileId = fileId;
        this.filename = filename;
    }
    serialization(stream) {
        this.fileId = serializationFileId(stream, this.fileId);
        this.filename = stream.utf16String(this.filename);
    }
    static is(msg) {
        return msg.type === ShareMediaFileMessage.typestatic;
    }
}
ShareMediaFileMessage.typestatic = "ShareMediaFileMessage";
ShareMediaFileMessage.subjectstatic = "general";
MessageFactory.register(ShareMediaFileMessage);
/**
 * Requests stopping media-file sharing.
 */
export class StopShareMediaFileMessage extends BusMessage {
    get byteLength() {
        return calcFileIdByteLength(this.fileId);
    }
    constructor(fileId) {
        super();
        this.fileId = fileId;
    }
    serialization(stream) {
        this.fileId = serializationFileId(stream, this.fileId);
    }
    static is(msg) {
        return msg.type === StopShareMediaFileMessage.typestatic;
    }
}
StopShareMediaFileMessage.typestatic = "StopShareMediaFileMessage";
StopShareMediaFileMessage.subjectstatic = "general";
MessageFactory.register(StopShareMediaFileMessage);
